import AppUpdateDetector from "@components/utils/AppUpdateDetector";
import MemberSettingsLoader from "@components/utils/MemberSettingsLoader";
import ThemeColorLoader from "@components/utils/ThemeColorLoader";
import { AppStatsigProvider } from "@configs/statsig/StatsigProvider";
import { ThemePreset } from "@configs/theme-preset";
import * as Sentry from "@sentry/react";
import { store } from "@stores";
import "@styles/App.css";
import { ThemeProvider } from "kz-ui-sdk";
import "kz-ui-sdk/dist/sdk-themes.css";
import "react-aspect-ratio/aspect-ratio.css";
import { Provider } from "react-redux";
import AppContent from "./AppContent";
import ErrorFallback from "./ErrorFallback";
import "./configs/i18n";

function App() {
  return (
    <ThemeProvider
      value={{
        preset: ThemePreset,
      }}
    >
      <Provider store={store}>
        <AppStatsigProvider>
          <ThemeColorLoader />
          <MemberSettingsLoader>
            <AppContent />
          </MemberSettingsLoader>
        </AppStatsigProvider>
        <AppUpdateDetector />
      </Provider>
    </ThemeProvider>
  );
}

export const EnhancedApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }: { error: unknown; resetError: () => void }) => (
    <ErrorFallback
      error={error}
      resetError={resetError}
    />
  ),
});

export default App;
